module.exports = __webpack_public_path__ + "static/fonts/fa-regular-400-19e27d348fefc21941e0310a0ec6339b.svg";